import request, { baseRequest } from 'tools/request'

// Bulk export of application attachments as ZIP files (one folder per application). Customer admins only,
// for clients with the APPLICATION_EXPORT flag. The selection is the applications list filters.

// { applications, files, estimatedBytes, filesWithUnknownSize, directDownloadAllowed, tooLarge, ... }
export const estimateAttachmentExport = (selection, demoMode = false) =>
  request('attachment-exports/estimate', 'POST', selection, false, { 'x-demo-mode': demoMode }, null, false, true)

// Starts a background export; the requester is emailed when it's ready.
export const createAttachmentExport = (selection, demoMode = false) =>
  request('attachment-exports', 'POST', selection, false, { 'x-demo-mode': demoMode })

// The current user's latest running or downloadable export, or false when there is none (204).
export const getLatestAttachmentExport = () =>
  request('attachment-exports/latest', 'GET', null, false, {}, null, false, true)

export const getAttachmentExport = (exportId) =>
  request(`attachment-exports/${exportId}`, 'GET', null, false, {}, null, false, true)

// A fresh 15-minute link to one ZIP part: { url }. The link downloads the file without leaving the page.
export const downloadAttachmentExportPart = async (exportId, partNo) => {
  const { url } = await request(`attachment-exports/${exportId}/parts/${partNo}/download`, 'GET')
  window.location.assign(url)
}

// Streams a small export straight to the browser and saves it. Rejects with the backend's message, e.g. when
// the selection grew past the direct-download limit since the estimate.
export const downloadAttachmentsNow = async (selection, demoMode = false) => {
  const res = await baseRequest('attachment-exports/download', 'POST', selection, { 'x-demo-mode': demoMode }, null, false)
  if (!res.ok) {
    let message = "The download couldn't be prepared."
    try {
      message = (await res.json())?.message || message
    } catch (e) {
      // keep the generic message
    }
    throw new Error(message)
  }
  const disposition = res.headers.get('content-disposition') || ''
  const match = /filename="?([^";]+)"?/i.exec(disposition)
  const blob = await res.blob()
  const href = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = href
  a.download = match ? match[1] : 'attachments.zip'
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(href)
}

// A silent request rejects with the unread Response; this pulls the backend's message out of it.
export const readErrorMessage = async (error, fallback) => {
  try {
    if (error && typeof error.json === 'function') {
      return (await error.json())?.message || fallback
    }
  } catch (e) {
    // fall through
  }
  return error?.message || fallback
}
